import extractErrorMessage from '../../../shared/utils/extractErrorMessage';
import { authClient } from '../../../shared/api/client';

const isOkStatus = (status) => status >= 200 && status < 300;

export const fetchTherapyOccurrences = async ({
  therapyId,
  page = 1,
  limit = 10,
  status = null,
}) => {
  try {
    if (!therapyId) {
      return {
        data: null,
        status: null,
        ok: false,
        message: 'Terapija nije izabrana.',
      };
    }

    let query = `?page=${page}&limit=${limit}`;
    if (status) query += `&status=${encodeURIComponent(status)}`;

    const response = await authClient.get(
      `/therapies/occurrences/${therapyId}${query}`
    );
    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri dobavljanju instanci terapije.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

export const updateTherapyOccurrenceStatus = async (occurrenceId, payload) => {
  try {
    const response = await authClient.put(
      `/therapy-occurrences/status/${occurrenceId}`,
      payload
    );
    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Status instance je azuriran.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri azuriranju statusa instance.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

export const updateTherapyOccurrenceNotification = async (
  occurrenceId,
  payload
) => {
  try {
    const response = await authClient.put(
      `/therapy-occurrences/notification/${occurrenceId}`,
      payload
    );
    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Obavestenje je azurirano.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri azuriranju obavestenja.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

export const fetchTherapyOccurrenceStatusLogs = async ({
  occurrenceId,
  page = 1,
  limit = 10,
}) => {
  try {
    if (!occurrenceId) {
      return {
        data: null,
        status: null,
        ok: false,
        message: 'Aktivnost nije izabrana.',
      };
    }
    const response = await authClient.get(
      `/therapy-occurrences/status-logs/${occurrenceId}?page=${page}&limit=${limit}`
    );
    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri dobavljanju istorije statusa.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

export const fetchTherapiesPerUserHistory = async ({
  userId,
  page = 1,
  limit = 10,
}) => {
  try {
    if (!userId) {
      return {
        data: null,
        status: null,
        ok: false,
        message: 'Korisnik nije izabran.',
      };
    }

    const response = await authClient.get(
      `/users/therapies/${userId}/history?page=${page}&limit=${limit}`
    );
    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri dobavljanju istorije terapija korisnika.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};
